import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import { n_landing } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import urls from '../../../../../modules/urls'
import { getDday } from '../../../../../modules/utils'
import useLandingNav, { checkIsSelected } from '../useLandingNav'

const SubNav = () => {
  const router = useAppRouter()
  const { t } = useTranslation()
  const { promotions } = useLandingNav()

  const promotion1DDay = promotions[0].dDay
    ? getDday(
        new Date(
          Date.UTC(
            promotions[0].dDay?.target_year,
            promotions[0].dDay?.target_month - 1,
            promotions[0].dDay?.target_day,
            promotions[0].dDay?.target_hour
          )
        )
      )
    : null
  const shouldShowDDay = promotion1DDay !== null && promotion1DDay >= 0 && promotion1DDay < 8
  const dDayLabel = shouldShowDDay ? (promotion1DDay === 0 ? 'D-Day' : `D-${promotion1DDay}`) : null

  const promotion2DDay = promotions[1].dDay
    ? getDday(
        new Date(
          Date.UTC(
            promotions[1].dDay?.target_year,
            promotions[1].dDay?.target_month - 1,
            promotions[1].dDay?.target_day,
            promotions[1].dDay?.target_hour
          )
        )
      )
    : null
  const shouldShowDDay2 = promotion2DDay !== null && promotion2DDay >= 0 && promotion2DDay < 8
  const dDayLabel2 = shouldShowDDay2 ? (promotion2DDay === 0 ? 'D-Day' : `D-${promotion2DDay}`) : null

  const subNavData = [
    {
      title: n_landing.mo_sub_menu.btn_home,
      link: urls.oneOnOne.index,
      isShow: true,
    },
    {
      title: promotions[0].label,
      link: promotions[0].link,
      dDay: dDayLabel,
      isShow: promotions[0].isPublic,
    },
    {
      title: promotions[1].label,
      link: promotions[1].link,
      dDay: dDayLabel2,
      isShow: promotions[1].isPublic,
    },
    {
      title: n_landing.sub_menu_1on1.list_1,
      link: urls.student.adv.index('/1on1/tutor'),
      isShow: true,
    },
    {
      title: n_landing.sub_menu_1on1.list_2,
      link: urls.student.adv.index('/1on1/material'),
      isShow: true,
    },
  ]

  const handleLinkClick = (link: string) => {
    router.push(link)
  }

  return (
    <nav className="px-14 h-[44px] w-full flex gap-x-10 bg-white/90 overflow-x-auto whitespace-nowrap no-scrollbar">
      {subNavData.map((nav, index) => {
        if (!nav.isShow) return null
        return (
          <button
            key={index}
            className={`p-8 ${checkIsSelected(router, nav.link) ? 'text-purple-600 border-b border-purple-600' : ''}`}
            onClick={() => handleLinkClick(nav.link)}
          >
            <div className="flex gap-x-4 items-center">
              <span className="Body2-14Md">{t(nav.title)}</span>
              {nav.dDay && <span className="px-6 Caption-12Bd bg-red-500 text-white rounded">{nav.dDay}</span>}
            </div>
          </button>
        )
      })}
    </nav>
  )
}

export default SubNav
